<span [style.color]="'#FFFFFF'" i18n [attr.data-testid]="'await-node-message'"
  >將會等待所有非同步的節點執行完畢後才繼續執行</span
>
